import { useMemo } from 'react';

import { useGetAnalyticsSelectionsQuery } from 'store/api/strapiService/analyticsController';

import Loader from 'components/Loader/Loader';
import Banner from 'components/pages/Analytics/Banner/Banner';
import Disclaimer from 'components/pages/Analytics/Disclaimer/Disclaimer';
import GamesByCategory from 'components/pages/Analytics/GamesByGategory/GamesByCategory';
import GamesByGeo from 'components/pages/Analytics/GamesByGeo/GamesByGeo';
import GamesByRetention from 'components/pages/Analytics/GamesByRetention/GamesByRetention';
import TopGames from 'components/pages/Analytics/TopGames/TopGames';

import styles from './Analytics.module.scss';

const Analytics = () => {
  const { data: topGames, isLoading: topGamesLoading } =
    useGetAnalyticsSelectionsQuery();

  const topGamesSectionsJSX = useMemo(
    () =>
      topGames?.data?.flatMap(
        ({ id, title, description, categories, games_icon, disabled }) =>
          !disabled
            ? [
                <TopGames
                  key={id}
                  title={title}
                  description={description}
                  categories={categories}
                  icon={games_icon}
                />,
              ]
            : [],
      ),
    [topGames],
  );

  return (
    <div className={styles.wrapper}>
      <Banner />
      <GamesByGeo />
      <GamesByCategory />
      <GamesByRetention />
      {!topGamesLoading ? topGamesSectionsJSX : <Loader />}
      <Disclaimer />
    </div>
  );
};

export default Analytics;
